import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {ApiGatewayService, DecryptedMessage, UserProfile} from 'src/app/services/api-gateway.service';
import {emitInfoMessage, InfoMessageService} from 'src/app/services/info-message.service';
import {DEFAULT_USERNAME, KeycloakUserService} from 'src/app/services/keycloak-user.service';
import {RouteAuthorizationService} from '../../services/route-authorization.service';

@Component({
    selector: 'tab-home',
    templateUrl: './tab-home.component.html',
    standalone: false
})
export class TabHomeComponent {
  toMakeButtons: any[] = [];

  username: string = DEFAULT_USERNAME;
  profile: UserProfile | null = null;
  homepageContent: 'messages' | 'get-started-with-multinode' | 'get-started' | 'loading' = 'loading';
  messages: DecryptedMessage[] | null = null;
  totalMessages: number = 0;
  selectedDeviceId: number | null = null;

  constructor(private infoMessageService: InfoMessageService,
              private gatewayApiService: ApiGatewayService,
              private keycloakUserService: KeycloakUserService,
              private router: Router,
              private routeAuthService: RouteAuthorizationService) {

    this.determineHomepageContent();
    this.initializeRoutes();

    // TODO: this seems unused
    this.username = this.keycloakUserService.username;
    if (this.username == DEFAULT_USERNAME) {
      this.keycloakUserService.usernameService$.subscribe($event => {
        if ($event != DEFAULT_USERNAME) {
          this.username = $event;
          this.keycloakUserService.usernameService$.unsubscribe();
        }
      })
    }

    // Determine which page to show based on user properties
  }

  async determineHomepageContent() {
    try{
      const profileResponse = await this.gatewayApiService.getUserProfile();
      if(profileResponse.body==null){
        this.homepageContent = 'get-started';
        return
      }
      this.profile = profileResponse.body;

      if (this.profile.onboarding_flow && this.profile.onboarding_flow == 'multinode') {
        await this.getDecryptedMessages().then((data) => {
          if(this.messages && this.messages?.length > 0){
            this.homepageContent = 'messages';
          }else{
            this.homepageContent = 'get-started-with-multinode';
          }
          return;
        })
      } else {
        this.homepageContent = 'get-started';
      }
    } catch (error: any) {
      console.error('Failed to fetch your profile:', error);
      // Dont show error because first time users will not have a profile (keycloak login) yet
      this.homepageContent = 'get-started';
    }
  }

  async initializeRoutes() {
    const routes = this.router.config;
    for (const route of routes || []) {

      if (route.data && route.data[0] >= 0 && route.path) {
        const canActivate = await this.routeAuthService.checkCanActivate(route);
        if (canActivate) {
          this.toMakeButtons.push({
            "path": "/" + route.path,
            "name": <string>(route.title),
            "icon": route.data[1]
          });
        }
      }
    }

  }

  async getDecryptedMessages(from: number = 1, to: number = 11, deviceId?: number | null){
    await this.gatewayApiService.getDecryptedMessages(from, to, deviceId ?? undefined)
      .then((data) => {
        if (data.body){
          if (data.body.length == 0){
            // emitInfoMessage("No messages found for your devices", this.infoMessageService)
            this.messages = []
          }else{
            this.messages = data.body
          }
        }
        // Content-Range: items=1-10/749
        const contentRange = data.headers.get('Content-Range');
        if (contentRange) {
          const match = contentRange.match(/items=\d+-\d+\/(\d+)/);
          if (match) {
            this.totalMessages = parseInt(match[1], 10);
          }
        }
      })
      .catch((error) => {
        emitInfoMessage(error.status +": "+ error.statusText, this.infoMessageService)
      })
  }

  onPageChange(event: {from: number, to: number}): void {
    this.getDecryptedMessages(event.from, event.to, this.selectedDeviceId);
  }

  onDeviceFilterChange(deviceId: number | null): void {
    this.selectedDeviceId = deviceId;
    this.getDecryptedMessages(1, 11, deviceId);
  }

  switchPage(page: 'messages' | 'get-started-with-multinode' | 'get-started' | 'loading') {
    this.homepageContent = page;
  }
}
